export class StockExchange {
  id: number;
  typeValue: string;
}

